export let CallDirection;
(function (CallDirection) {
  CallDirection["INBOUND"] = "INBOUND";
  CallDirection["OUTBOUND"] = "OUTBOUND";
})(CallDirection || (CallDirection = {}));